<button
  type="button"
  class="my-app-tile"
  [class.my-app-tile--aya]="tileVariant === 'aya'"
  [class.my-app-tile--aya-product]="tileVariant === 'ayaProduct'"
  [class.my-app-tile--disabled]="disabled"
  [disabled]="disabled"
  (click)="onClick()"
>
  <span
    *ngIf="tileVariant === 'ayaProduct'"
    class="my-app-tile__glow"
    aria-hidden="true"
  ></span>

  <span *ngIf="preview" class="my-app-tile__preview" aria-hidden="true">
    <span
      class="my-app-tile__preview-label"
      [ngClass]="{ 'my-app-tile__preview-label--purple': previewVariant === 'purple' }"
    >Preview</span>
  </span>

  <span class="my-app-tile__body">
    <span class="my-app-tile__logo-row">
      <span class="my-app-tile__icon-wrap">
        <img
          [src]="iconSrc"
          [alt]="iconAlt"
          class="my-app-tile__icon"
          [ngClass]="[iconClassName, largeLogo ? 'my-app-tile__icon--logo' : '']"
        />
      </span>
      <span
        *ngIf="!hideTitle"
        class="my-app-tile__title"
        [ngClass]="titleClassName"
      >{{ title }}</span>
    </span>
    <span
      class="my-app-tile__subtitle"
      [class.my-app-tile__subtitle--aya]="tileVariant === 'aya'"
    >{{ subtitle }}</span>
  </span>
</button>
